import toastMessage from "../toastMessage";
import { getStorage } from "../storage";
import language from "../../language";
import { defineRole } from "../handleAccessRoles";
import { ROLE_COLLECTION_TYPE } from "../../constants/ROLES";
import api from "../api";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

export const fetchCollectionTypes = async (
  lng = "english",
  { page, limit, type, id, collectionTypeNumber }
) => {
  try {
    const user = await getStorage();

    const canAccess = defineRole({
      roles: user.accessRole,
      menu: ROLE_COLLECTION_TYPE,
      operation: "read,readOnAction",
    });

    if (!canAccess) return;

    const options = {
      method: "GET",
      url: `${API_URL}/collectionType`,
      params: {
        page: page,
        limit: limit,
        id,
        collectionTypeNumber,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    const queryRes = await api(options);

    if (type === "dropdown") {
      const items = Array.isArray(queryRes.data?.data)
        ? queryRes.data.data
        : Array.isArray(queryRes.data)
        ? queryRes.data
        : [];
      return items.map((el) => ({
        ...el,
        label: el.collectionTypeNumber + " - " + el.name,
        value: el._id,
      }));
    }

    let { data, count, totalRecords } = queryRes.data;

    return !page && !limit ? queryRes.data : { data, count, totalRecords };
  } catch (error) {
    toastMessage("error", error);
  }
};

export const deleteCollectionType = async (lng = "english", id) => {
  try {
    const user = await getStorage();

    const canAccess = defineRole({
      roles: user.accessRole,
      menu: ROLE_COLLECTION_TYPE,
      operation: "delete",
    });

    if (!canAccess) return;

    const options = {
      method: "DELETE",
      url: `${API_URL}/collectionType`,
      data: {
        id,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    await api(options);

    toastMessage("success", language[lng].add_data_success);
  } catch (error) {
    toastMessage("error", error);
  }
};
